import { render, staticRenderFns } from "./resblock-item.vue?vue&type=template&id=75d8f350&scoped=true&"
import script from "./resblock-item.vue?vue&type=script&lang=js&"
export * from "./resblock-item.vue?vue&type=script&lang=js&"
import style0 from "./resblock-item.vue?vue&type=style&index=0&id=75d8f350&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d8f350",
  null
  
)

export default component.exports